'use strict';

var _ = require('lodash');
function SystemStatusInterfaceStatusAllFiltersFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['SystemStatusInterfaceStatusFilterByFileEventsFactory', 'SystemStatusInterfaceStatusFilterByEventDirectionFactory', 'SystemStatusInterfaceStatusFilterByEventFrequencyFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function SystemStatusInterfaceStatusAllFilters() {
    DemandFilter.call(this, ['system-status-interface-status-mode'], ['system-status-interface-status']);
    this.registerFilters(injectedFilters);
  }
  SystemStatusInterfaceStatusAllFilters.constructor = SystemStatusInterfaceStatusAllFilters;
  SystemStatusInterfaceStatusAllFilters.prototype = Object.create(DemandFilter.prototype);
  SystemStatusInterfaceStatusAllFilters.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  SystemStatusInterfaceStatusAllFilters.prototype.filter = function (data) {
    var filterStrategies = _.orderBy(this.filterStrategies, 'priority');
    return _.reduce(filterStrategies, function (filteredData, filterStrategy) {
      return filterStrategy.filter(filteredData);
    }, data);
  };
  return SystemStatusInterfaceStatusAllFilters;
}
SystemStatusInterfaceStatusAllFiltersFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = SystemStatusInterfaceStatusAllFiltersFactory;